/* eslint-disable */
(function($){
    const App = {
        homeMobMenu() {
            $("#mobile-bars").sidr({
              name: "sidr",
              side: "left",
              speed: 400,
              displace: false,
              timing: "ease",
              onOpen() {
                $("#mobile-bars i").removeClass("fa-bars").addClass("fa-times");
                $("body").css({
                  position: "fixed",
                  width: "100%",
                  background: "rgba(0, 0, 0, 0.5)",
                });
                $("#sidr").css('display', 'block');
              },
              onClose() {
                $("#mobile-bars i").removeClass("fa-times").addClass("fa-bars");
                $("body").css({
                  position: "static",
                  width: "auto",
                  background: "transparent",
                });
                
              },
            });
            $('#sidr').css('display', 'block');
            $(document).on("click", function (e) {
              if (!$(e.target).closest("#sidr").length) {
                  $.sidr( 'close', 'sidr' );
              }
            });
      
            /*sidr sub menu*/
            const sidrParentMenu = $("#sidr #mobile-view li.menu-item-has-children");
            const sidrSubmenu = $("#sidr #mobile-view ul.sub-menu");
            const parentAncor = $(
              "#sidr #mobile-view li.menu-item-has-children"
            ).children("a");
      
            $('<i class="fa-solid fa-chevron-down"></i>').appendTo(parentAncor);
            sidrSubmenu.hide();
            sidrParentMenu.children("a").on("click", function (e) {
              e.preventDefault();
              $(this).next("ul.sub-menu").stop().slideToggle();
              $(this).children("i").toggleClass("fa-chevron-down fa-chevron-up");
            });
            $('ul#mobile-view li.menu-item-has-children a').css({'display': 'flex', 'justify-content' : 'space-between', 'align-items' : 'center'});
            
          },
            testimonialSlider(){
            let swiped = new Swiper(".testimonial-slider", {
                  spaceBetween: 30,
                  effect: "fade",
                  loop: true,
                //   autoplay: {
                //       delay: 4000,
                //       disableOnInteraction: false,
                //     },
            })
          },
          backtrackVenobox(){
            $('.image-popup').venobox({
                bgcolor: '#3C92CA',
                numeration: true,
                spinner: 'wandering-cubes'
            });
            
          },
          journeySlider(){
            var swiper = new Swiper(".journey-gallery", {
              slidesPerView: 1,
              spaceBetween: 30,
              loop: true,
              setWrapperSize: true,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
            //   breakpoints: {
            //     768: {
            //       slidesPerView: 1,
            //       spaceBetween: 20,
            //     },
            //   },
            });
          },
          fullWidthCarousel(){
            var swiper = new Swiper(".full-width-swiper-slide", {
              slidesPerView: 1,
              spaceBetween: 30,
              loop: true,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              },
              breakpoints: {
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                }
              },
            });
          },
        backtrackTab(){
            let tabEl = $(".backtrack-tab button");
            let tabContent = $('.tab-content .tab-pane');
            tabEl.on("click", function(){
                tabEl.removeClass('active');
                $(this).addClass('active');
                $('.tab-pane').removeClass('show active');
                
                let activeTab = $(this).attr("data-bs-target");
                $(`.tab-content ${activeTab}`).addClass("show active");
            });
        },
        backtrackAccordion(){
          const accordion = document.getElementsByClassName("accordion-box");

          for(i = 0; i < accordion.length; i++){
            accordion[i].addEventListener('click', function(){
              this.classList.toggle('active');
            });
          }
        },
        backtrackSwiperGallery(){
          var galleryThumbs = new Swiper(".gallery-thumbs", {
            centeredSlides: false,
            centeredSlidesBounds: true, 
            direction: "horizontal",
            spaceBetween: 10,
            slidesPerView: 3,
            freeMode: false,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            watchOverflow: true,
            breakpoints: {
              480: {
                direction: "vertical",
                slidesPerView: 3
              }
            },
            on: {
              reachEnd: function() {
                this.snapGrid = [...this.slidesGrid];
              },
            }
          });
          var galleryTop = new Swiper(".gallery-top", {
            direction: "horizontal",
            slidesPerView: "auto",
            spaceBetween: 10,
            navigation: {
              nextEl: ".gallery-button-next",
              prevEl: ".gallery-button-prev"
            },
            // a11y: {
            //   prevSlideMessage: "Previous slide",
            //   nextSlideMessage: "Next slide",
            // },
            keyboard: {
              enabled: true,
            },
            thumbs: {
              swiper: galleryThumbs
            },
          });
          galleryTop.on("slideChangeTransitionStart", function () {
            galleryThumbs.slideTo(galleryTop.activeIndex);
          });
          galleryThumbs.on("transitionStart", function () {
            galleryTop.slideTo(galleryThumbs.activeIndex);
          });
        },
        backtrackModal(){
         $(document).ready(function(){
            $("#modalBtn").on("click", function(){
              $("body").addClass("modal-open");
            });
            $(".closeModal").on("click", function(){
              $("body").removeClass("modal-open");
            });
          });
        },
          
    }

    App.init = function(){
        App.homeMobMenu();
        App.backtrackVenobox();
        App.journeySlider();
        App.fullWidthCarousel();
        App.backtrackTab();
        App.backtrackAccordion();
        App.backtrackSwiperGallery();
        App.backtrackModal();
    }
    $(function(){
        App.init();
        
    });
})(jQuery);